<template>
  <div :class="b()">
    <!-- @slot Use this for multiple c-collapsible items -->
    <slot></slot>
  </div>
</template>

<script>
  /**
   * Wrapper for multiple (c-collapse) items.
   */
  export default {
    name: 'c-collapse-group',

    // components: {},
    // mixins: [],

    props: {
      /**
       * Defines if items can be open simultaneously
       */
      oneActive: {
        type: Boolean,
        default: true,
      },
    },
    // data() {
    //   return {};
    // },

    // computed: {},
    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    mounted() {
      /**
       * Emits toggled event
       */
      this.$mitt.on('c-collapse.toggled', (payload) => {
        const { component, relevantParent } = payload;

        /**
         * Receives update from child and emits update to EventBus
         *
         * @event   c-collapse-group.toggle
         * @type      {object}  payload
         * @property  {object}  payload.component         Current c-collapse-group instance
         * @property  {object}  payload.toggleCollapse    Component instance of original event
         */
        if (this.oneActive && relevantParent === this) {
          this.$mitt.emit('c-collapse-group.toggle', { component: this, toggledCollapse: component });
        }
      });
    },
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    // methods: {},
    // render() {},
  };
</script>
